import { Container, Fade, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'next-i18next'
import Lottie from 'react-lottie-player'
import lottieJson from './lottie.json'

function Loader({ active }) {
  const { t } = useTranslation(['common', 'register'])

  const [current, setCurrent] = React.useState(0)
  const loadingTexts = [
    t('register:This_may_take_a_bit_of_time'),
    t('register:Preparing_your_institution_data'),
    t('register:Building_your_domain'),
  ]

  React.useEffect(() => {
    setCurrent(() => 0)
    let timer
    if (active)
      timer = setInterval(() => setCurrent((prev) => (prev + 1) % loadingTexts.length), 5000)
    else if (timer) clearInterval(timer)
    return () => timer && clearInterval(timer)
  }, [active])

  return (
    <Container maxWidth="md">
      <Stack
        height="75vh"
        justifyContent="center"
        alignItems="center"
      >
        <Lottie
          loop
          animationData={lottieJson}
          play
          style={{ width: '100%', height: 300 }}
        />
        {loadingTexts.map((text, index) => (
          <Fade
            key={index}
            in={current === index}
            sx={{ display: current === index ? '' : 'none' }}
          >
            <Typography
              variant="h5"
              color="primary.main"
              align="center"
            >
              {text}
            </Typography>
          </Fade>
        ))}
      </Stack>
    </Container>
  )
}

export default Loader
